import dayjs from "dayjs";

export const createStatusDate = (date: Date) => {
    const dateObj = dayjs();
    const todayYear = dateObj.year();
    const todayMonth = dateObj.month();
    const nextYear = dateObj.add(1, "year").year();
    const nextMonth = dateObj.add(2, "month").month();
    const todayDay = dateObj.day();
    const todayDate = dateObj.date();

    const currentDate = dayjs(date);
    const lastDate = currentDate.endOf("month").date();

    const currentFirstDay = currentDate.startOf("month").day();

    let datesArray;
    let backLength: number;

    if (date.getFullYear() === todayYear && date.getMonth() === todayMonth) {
        let nextMonthDateNum = 1;
        const frontNonDates = Array.from({ length: todayDay }, () => ({ date: "" }));
        const realDates = Array.from({ length: lastDate + 1 }, (_, index) => {
            if (lastDate - todayDate < index) {
                return { date: `${nextMonth}/${nextMonthDateNum++}` };
            } else {
                return { date: `${index + todayDate}` };
            }
        });

        backLength =
            7 - (dayjs(`${nextMonth === 1 ? nextYear : todayYear}/${realDates[realDates.length - 1].date}`).day() + 1);

        const backNonDates = Array.from({ length: backLength }, () => ({ date: "" }));
        datesArray = [...frontNonDates, ...realDates, ...backNonDates];
    } else {
        const frontNonDates = Array.from({ length: currentFirstDay }, () => ({ date: "" }));
        const realDates = Array.from({ length: lastDate }, (_, index) => ({ date: index + 1 }));

        backLength = 7 - (dayjs(date).endOf("month").day() + 1);
        const backNonDates = Array.from({ length: backLength }, () => ({ date: "" }));
        datesArray = [...frontNonDates, ...realDates, ...backNonDates];
    }

    return { datesArray, backLength };
};
